import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function load (component) {
  return () => System.import(`../components/${component}.vue`)
}

import { prefix } from '../config/api'

export default new VueRouter({
  mode: "history", // disabled hastag "#" on routes
  routes: [
    {
      // only routes with countries
      path: "/:country",
      component: load("public/Prefix"),
      children: [
        {
          // Route register Patient
          path: "register/:type?",
          name: "register.patient",
          component: load("public/RegisterPatient"),
          meta: {
            name: "Registro"
          }
        },
        {
          // Route login Patient
          path: "/",
          name: "login.patient",
          component: load("public/LoginPatient"),
          meta: {
            forVisitors: true,
            name: "Login"
          }
        },
        {
                    // Route login doctor
                    path: 'recovery',
                    name: 'recovery.doctor',
                    component: load("public/Recovery"),
                    meta: {
                        forVisitors: true,
                        name: 'Recuperar Contraseña'
                    }
                },

        {
          // Route logout
          path: "logout",
          name: "logout",
          component: load("Logout"),
          meta: {
            requiresAuth: true,
            name: "Logout"
          }
        },
        {
          // Route dashbaord - need authentication
          path: "/",
          name: "dashboard.layout",
          component: load("patient/partials/Layout"),
          meta: {
            requiresAuth: true
          },
          children: [
            // Route dashboard
            {
              path: "dashboard",
              name: "dashboard",
              component: load("patient/Dashboard"),
              meta: { name: "Dashboard" },
              children: []
            },
            {
              path: "reserves",
              name: "dashboard.reserves",
              component: load("patient/InfoPanel/Reserves"),
              meta: { name: "Panel de Información" }
            },
            {
              path: "appointments",
              name: "dashboard.appointments",
              component: load("patient/InfoPanel/Appointments"),
              meta: { name: "Panel de Información" }
            },
            {
              path: "info",
              name: "dashboard.info",
              component: load("patient/InfoPanel/Info"),
              meta: { name: "Panel de Información" }
            },
            // Route profile
            {
              path: "profile",
              name: "dashboard.profile",
              component: load("patient/ProfilePatient"),
              meta: { name: "Datos Personales" }
            },
            // Route subyacente
            {
              path: "underlying",
              name: "underlying",
              component: load("patient/Underlying/Index"),
              meta: { name: "Cargas" }
            },
            // Route bonos
            {
              path: "bonuses",
              name: "bonuses",
              component: load("patient/Bonuses/Index"),
              meta: { name: "Historial de Bonos" }
            },
            // Route bonos register
            {
              path: "bonuses/register",
              name: "bonuses.register",
              component: load("patient/Bonuses/Register"),
              meta: { name: "Emision de Bonos" }
            }
          ]
        },
        {
          // Route 404
          path: "*",
          name: "notfound",
          component: load("error/404"),
          meta: {
            name: "Not Found"
          }
        }
      ],
      meta: {
        prefix: true
      }
    },
    {
      // redirect prefix "cl" by default
      path: "/",
      redirect: "/" + prefix[0]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js